export default [
  {
    path: '/superUpstream',
    redirect: '/superUpstream/index',
    component: {
      render() {
        return (
          <keep-alive include={this.$store.state.viewsCache.caches}>
            <router-view />
          </keep-alive>
        );
      },
    },
    children: [
      {
        path: 'index',
        name: 'lkl',
        component: () => import('@/views/superPages/lkl'),
      },
      {
        path: 'lsyShare',
        name: 'lsyShare',
        component: () => import('@/views/superPages/lkl/lsyShare.vue'),
      },
      {
        path: 'ysmpShare',
        name: 'ysmpShare',
        component: () => import('@/views/superPages/ysmp/ysmpShare.vue'),
      },
      {
        path: 'dxmdk',
        name: 'dxmdk',
        component: () => import('@/views/superPages/dxmdk/index.vue'),
      },
      {
        path: 'dxmdkShare',
        name: 'dxmdkShare',
        component: () => import('@/views/superPages/dxmdk/dxmdkShare.vue'),
      },
      {
        path: 'mt',
        name: 'mt',
        component: () => import('@/views/superPages/mt/index.vue'),
      },
      {
        path: 'mtOrder',
        name: 'mtOrder',
        component: () => import('@/views/superPages/mt/mtOrder.vue'),
      },
      {
        path: 'lt',
        name: 'lt',
        component: () => import('@/views/superPages/lt/index.vue'),
      },
       {
        path: 'ysmp',
        name: 'ysmp',
        component: () => import('@/views/superPages/ysmp/index.vue'),
      },
       {
        path: 'lsjj',
        name: 'lsjj',
        component: () => import('@/views/superPages/lsjj/index.vue'),
      },
      {
        path: 'lsjjShare',
        name: 'lsjjShare',
        component: () => import('@/views/superPages/lsjj/lsjjShare.vue'),
      },
      {
        path: 'lklgz',
        name: 'lklgz',
        component: () => import('@/views/superPages/lklgz/index.vue'),
      },
      {
        path: 'sybEntry',
        name: 'sybEntry',
        component: () => import('@/views/superPages/sybEntry/index.vue'),
      },
      {
        path: 'sybCardShare',
        name: 'sybCardShare',
        component: () => import('@/views/superPages/sybEntry/sybCardShare.vue'),
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/superPages/brand/index.vue'),
      },
      {
        path: 'wpgj',
        name: 'wpgj',
        component: () => import('@/views/superPages/wpgj/index.vue'),
      },
      {
        path: 'wpgjShare',
        name: 'wpgjShare',
        component: () => import('@/views/superPages/wpgj/wpgjShare.vue'),
      },
      {
        path: 'douyin',
        name: 'douyin',
        component: () => import('@/views/superPages/douyin/index.vue'),
      },
    ],
  },
];